import "core-js/modules/es.string.link.js";
import { formatColorToRgba } from "../../core/helpers/formatColorToRgba";
export var linkPortalTokens = {
  borderWidth: "0.4px",
  base: {
    textColor: function textColor(_ref) {
      var color = _ref.color;
      return color.text.link.base;
    },
    borderColor: function borderColor(_ref2) {
      var color = _ref2.color;
      return formatColorToRgba(color.text.link.base, 0.2);
    }
  },
  hover: {
    textColor: function textColor(_ref3) {
      var color = _ref3.color;
      return color.text.link.hover;
    },
    borderColor: function borderColor(_ref4) {
      var color = _ref4.color;
      return formatColorToRgba(color.text.link.hover, 0.2);
    }
  },
  visited: {
    textColor: function textColor(_ref5) {
      var color = _ref5.color;
      return color.text.link.visited;
    },
    borderColor: function borderColor(_ref6) {
      var color = _ref6.color;
      return formatColorToRgba(color.text.link.visited, 0.2);
    }
  },
  asButton: {
    disabledStyle: {
      opacity: 0.5
    }
  }
};